import wetvKernel from '@tencent/wetv-kernel';
import { qua, getAppid, beforeRequest } from '../util/util';
const { fetcher } = wetvKernel;
const { configInstace } = wetvKernel;
const {
  // vipDomain,
} = configInstace;
const { videoAppid } = getAppid();

export default {
  paidCode: async (body, params) => {
    beforeRequest();
    return await fetcher.get(
      `https://${configInstace?.vipDomain}/${global.base.paidCode}`,
      body,
      {
        CSRF: true,
        originReturn: true,
        withCredentials: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  ProcessTVPreAuth: async (body, params) => {
    beforeRequest();
    return await fetcher.get(
      `https://${configInstace?.vipDomain}/${global.base.ProcessTVPreAuth}`,
      body,
      {
        CSRF: true,
        originReturn: true,
        withCredentials: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  CreateGuidIntl: async (params) => {
    beforeRequest();
    return await fetcher.get(
      `https://${configInstace?.vipDomain}/${global.base.CreateGuidIntl}`,
      params,
      {
        CSRF: true,
        originReturn: true,
        withCredentials: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetMsgIntl: async (params) => {
    beforeRequest();
    return await fetcher.get(
      `https://${configInstace?.vipDomain}/${global.base.GetMsgIntl}`,
      params,
      {
        CSRF: true,
        originReturn: true,
        withCredentials: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
};
